export default __webpack_public_path__ + "static/media/WAS0333.34I-41674_-24945_0.4a7dc809.jpg";